import {
	GROUP_TYPE,
	CURSOR,
	getTextColor,
	GROUP_SECTION_WIDTH,
	drawRectangle,
	drawExpansionIcon,
	drawArrows,
	COMMON_IMAGE,
	GROUP_SECTION_SPACING_LEVEL_TWO,
	GROUP_SECTION_PADDING_LEFT,
	drawBorder,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_TEXT_GREY_DARK,
	GROUP_SECTION_EXPAND_ICON_HEIGHT,
	GROUP_SECTION_EXPAND_ICON_WIDTH
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class ProjectSubGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT_SUB_GROUP, data);
		this.expanded = data.id.includes('phase');
	}

	refreshData(updatedProject) {
		this.data.color = updatedProject.projectColor;
	}

	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this);
			const {name, id, color, phases, groups, count, isInProjectGroup, projectGroupColor} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const isMilestoneSubGroup = data.id.includes('phases');
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);
			const borderThickness = 1;

			const textColor = getTextColor(color);
			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				canvasContext.fillStyle = textColor;
				canvasContext.fillText(`${name} (${isMilestoneSubGroup ? phases.length : groups ? groups.filter(group => !group.filtered).length : count !== undefined ? count : '-'})`, x + 53, y + 24);
				return;
			}

			// draw left connected project border color
			if (isInProjectGroup && projectGroupColor) {
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height + (borderThickness * 2),
					true,
					projectGroupColor,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			const drawGroup = icon => {
				const iconHeight = 19;
				const iconWidth = 24;
				const topBottomBorderThickness = 1;
				let fontSize = 13;
				const connectedProjectOffset = isInProjectGroup && isMilestoneSubGroup ? GROUP_SECTION_PADDING_LEFT : 0;

				drawRectangle(
					canvasContext,
					x + connectedProjectOffset + GROUP_SECTION_MARGIN_LEFT,
					y,
					width,
					height,
					{
						borderThickness: 0,
					}
				);

				// right project color
				if (!isInProjectGroup) {
					drawBorder(
						canvasContext,
						x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
						y - 2 - topBottomBorderThickness,
						height,
						true,
						color,
						GROUP_SECTION_PROJECT_BORDER_WIDTH,
					);
				}

				const borderWidth = isInProjectGroup
					? width - GROUP_SECTION_MARGIN_LEFT
					: width - GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH;

				// top border
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y - 1,
					borderWidth,
					false,
					'#E7E7F3',
				);

				// bottom border
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y - 1 + height,
					borderWidth,
					false,
					'#E7E7F3',
				);

				canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_DARK;

				// expansion icon
				canvasContext.drawImage(
					cacheManager.getCommonImage(expanded ? COMMON_IMAGE.EXPAND_GROUP_ICON : COMMON_IMAGE.EXPAND_GROUP_CLOSED_ICON),
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_TWO - (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
					y + (height / 2) - (GROUP_SECTION_EXPAND_ICON_HEIGHT / 2),
					GROUP_SECTION_EXPAND_ICON_WIDTH,
					GROUP_SECTION_EXPAND_ICON_HEIGHT,
				);

				// phases / project team icon
				canvasContext.drawImage(
					isMilestoneSubGroup ? cacheManager.getCommonImage(COMMON_IMAGE.PHASES_BLACK) : cacheManager.getCommonImage(COMMON_IMAGE.PROJECT_TEAM_BLACK),
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_TWO + GROUP_SECTION_PADDING_LEFT + (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
					y + (height / 2) - (iconHeight / 2),
					iconWidth,
					iconHeight,
				);

				// title 'Project Team (x)' / 'Phase (x)'
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const sum = isMilestoneSubGroup
					? phases.length
					: groups
						? groups.filter(group => !group.filtered).length
						: count !== undefined ? count : '-';
				const title = `${name} (${sum})`;
				canvasContext.fillText(
					title,
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_TWO + iconWidth + (GROUP_SECTION_PADDING_LEFT * 2),
					y + (height / 2) + (fontSize / 3),
				);
			};
			drawGroup(cacheManager.getCommonImage(COMMON_IMAGE[`${isMilestoneSubGroup ? 'MILESTONE_ICON_' : 'PROJECT_TEAM_ICON_'}${textColor === '#ffffff' ? 'WHITE' : 'BLACK'}`]));
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this);
			const {name, id, color, phases, groups, count} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const isMilestoneSubGroup = data.id.includes('phases');
			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const textColor = getTextColor(color);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				canvasContext.fillStyle = textColor;
				canvasContext.fillText(
					`${name} (${
						isMilestoneSubGroup
							? phases.length
							: groups
								? groups.filter(group => !group.filtered).length
								: count !== undefined
									? count
									: '-'
					})`,
					x + 53,
					y + 24
				);
				return;
			}

			const drawGroup = icon => {
				const yOffset = data.projectGroupTeam ? 1 : isMilestoneSubGroup ? 0 : -1;
				drawRectangle(
					canvasContext,
					x + (data.isInProjectGroup && !data.projectGroupTeam ? 16 : 10),
					y + yOffset,
					width - 10 - (data.isInProjectGroup && !data.projectGroupTeam ? 6 : 0),
					height - yOffset,
					{
						backgroundColor: color,
						borderColor: '#ffffff',
						borderThickness: 1,
					}
				);
				if (!data.preventExpansion) {
					drawExpansionIcon(canvasContext, x, y, width, height, {
						backgroundColor: color,
						expanded,
					});
				}

				canvasContext.fillStyle = textColor;
				canvasContext.font = '500 10px ' + Util.getFontFamily();
				if (icon) {
					canvasContext.drawImage(icon, x + 25, y + 12, 14, 14);
				}
				if (isMilestoneSubGroup && phases.filter(phase => phase.startDay && phase.deadlineDay).length) {
					drawArrows(
						canvasContext,
						textColor,
						x + 155,
						y + 14,
						cacheManager.getCommonImage(
							COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_PREVIOUS_WHITE' : 'GO_TO_PREVIOUS']
						),
						cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'GO_TO_NEXT_WHITE' : 'GO_TO_NEXT'])
					);
				}
			};
			drawGroup(
				cacheManager.getCommonImage(
					COMMON_IMAGE[
						`${isMilestoneSubGroup ? 'MILESTONE_ICON_' : 'PROJECT_TEAM_ICON_'}${
							textColor === '#ffffff' ? 'WHITE' : 'BLACK'
						}`
						]
				)
			);
			canvasContext.fillStyle = textColor;
			canvasContext.fillText(
				`${name} (${
					isMilestoneSubGroup
						? phases.length
						: groups
							? groups.filter(group => !group.filtered).length
							: count !== undefined
								? count
								: '-'
				})`,
				x + 53,
				y + 24
			);
		}
	}
}

export default ProjectSubGroup;
